import types from 'redux/actions/actionTypes';
import { PaginationOptions } from 'react-data-table-component';
import { axiosV2 } from 'interceptors/axios';

import { Partner } from 'types';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

import { updateSocietyData } from 'modules/society/redux/updateSocietyData';

type UpdatePartnerProps = {
  partnerId: string;
  updatePartnerData: Partial<Partner> & {
    userId: string;
    society: string;
    societyId?: string;
  };
  showAlert?: boolean;
};

export const addPartner =
  (partner: Partial<Partner>) => async (dispatch: any) => {
    // TODO: Implement cleaning and validation of partner data before sending to the server
    try {
      const { data } = await axiosV2.post('/partners', partner);
      const decodedData: any = await decryptResponse(data);

      dispatch({
        type: types.CREATE_PARTNER,
        partner: decodedData.newPartner,
      });

      updateSocietyData(decodedData, dispatch);

      return decodedData.newPartner;
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      return dispatchError(error, dispatch);
    }
  };

export const getPartners =
  (societyId: string, params: any = {}, source = 'list') =>
  async (dispatch: any) => {
    const query = { params: { societyId, ...params, source } };

    try {
      const { data } = await axiosV2.get('/partners', query);

      const decodedData = (await decryptResponse(data)) as {
        data: Partner[];
        pagination: PaginationOptions;
      };
      const partners = decodedData.data;

      dispatch({
        type: types.GET_PARTNERS,
        partners,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const getPartner =
  (partnerId: string, params = {}) =>
  async (dispatch: any) => {
    const query = { params };

    try {
      const { data } = await axiosV2.get(`/partners/${partnerId}`, query);
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const updatePartner =
  ({ partnerId, updatePartnerData }: UpdatePartnerProps) =>
  async (dispatch: any) => {
    const body = { ...updatePartnerData };

    const { data } = await axiosV2.put(`/partners/${partnerId}`, body);
    const decodedData = await decryptResponse(data);

    dispatch({
      type: types.UPDATE_PARTNER,
      partner: decodedData,
    });
  };

export const deletePartner = (partnerId: string) => async (dispatch: any) => {
  try {
    await axiosV2.delete(`/partners/${partnerId}`);

    dispatch({
      type: types.DELETE_PARTNER,
      partnerId,
    });
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
    return dispatchError(error, dispatch);
  }
};
